import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { CsiteSupplier, House } from '@arpada/arp-lib-common-qupro';
import { ActionsSharedData } from '../actions.shared.data';
import { ConformesFilterComponentsValues } from '../../../../models/components-values/conformes.filter.values';
import { ConformesFilter, PortalProveedorService } from '../../../../services/api.services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-filter-conforme',
  templateUrl: './filter-conforme.component.html',
  styleUrls: ['./filter-conforme.component.scss'],
})
export class FilterConformeComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() sharedData: ActionsSharedData;
  @Input() filter: ConformesFilter;
  @Input() filterChange = new EventEmitter();
  @Input() isModal: boolean;

  @ViewChild('filterForm', { static : true }) filterForm: NgForm;
  @ViewChild('csitesSelectable', { static: true }) csitesSelectable: IonicSelectableComponent;

  houses: House[] = [];
  detectChanges = false;
  csiteSelected = false;
  enviromentSelected = false;
  portalSelected = false;
  floorSelected = false;
  componentsValues: ConformesFilterComponentsValues = null;
  portals: string[] = [];
  floors: string[] = [];
  letters: string[] = [];
  private modalId: string = null;
  private detectChangesSubscription: Subscription = null;
  private loginRedirectSubscription: Subscription;

  constructor(
    private modalController: ModalController, 
    private portalProveedorService: PortalProveedorService, 
    ) { }

  ngOnInit() {
    this.modalController.getTop().then((top: HTMLIonModalElement) => {
      this.modalId = top.id; // Get modal ID for close it
    });
    this.componentsValues = {
      validIsChecked: true,
      invalidIsChecked: false,
      csiteId: this.filter ? this.filter.csite_id : null,
      idSelected: this.filter ? this.filter.id : null,
      commonArea: this.filter ? this.filter.common_area : null,
      portal: this.filter ? this.filter.portal : null,
      floor: this.filter ? this.filter.floor : null,
      door: this.filter ? this.filter.letter : null,
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.detectChanges = true;
      this.detectChangesSubscription = this.filterForm.valueChanges.subscribe(this.onChangeComponent);
    });
  }

  onChangeComponent = () => {
    if (this.detectChanges) {
      setTimeout(() => {
        this.updateFiltro();
      }, 50); // Time to apply filters, after change this.filter
    }
  }

  ngOnDestroy() {
    if (this.detectChangesSubscription) {
      this.detectChangesSubscription.unsubscribe();
    }
    this.detectChanges = false;
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  isTotalCountDefined() {
    return this.sharedData && this.sharedData.totalCount
      && this.sharedData.totalCount !== '' && parseInt(this.sharedData.totalCount, 10) >= 0;
  }

  clearCsitesSelectedItems() {
    this.componentsValues.csiteId = null;
    this.updateFiltro();
  }

  onSelectCsitesId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: CsiteSupplier}) {
    if (!this.componentsValues.csiteId) {
      this.componentsValues.csiteId = null;
    }
    const index: number = this.componentsValues.csiteId = eventSelectable.item.id;
    if (eventSelectable.isSelected) {
      if (index > 0) {
        this.componentsValues.csiteId = eventSelectable.item.id;
        this.csiteSelected = true;
      }
    } else {
      // creo que no hace falta
      // console.log('this.componentsValues.csiteId: ', this.componentsValues.csiteId);
      this.csiteSelected = false;
    }
    setTimeout(() => {
      this.updateFiltro();
    }, 50); // Time to apply filters, after change this.filter
  }

  selectEnvironment() {
    this.portals = [];
    if (this.componentsValues.commonArea || this.componentsValues.commonArea === 0 ) {
      this.enviromentSelected = true;
      let commonArea = false;
      if (this.componentsValues.commonArea === 1) {
        commonArea = true;
      }
      this.portalProveedorService.getCachedHouses(this.componentsValues.csiteId, commonArea).subscribe(resp => {
        this.houses = resp.elements;
        this.houses.forEach(house => {
          this.portals.push(house.portal);
        });
        this.portals = this.removeDuplicados(this.portals);
      });
    } else {
      this.enviromentSelected = false;
      this.componentsValues.portal = null;
      this.selectPortal();
    }
  }

  selectPortal() {
    this.floors = [];
    this.portalSelected = false;
    this.componentsValues.floor = null;
    if (this.componentsValues.portal) {
      this.houses.forEach(house => {
        if (this.componentsValues.portal === house.portal) {
          this.floors.push(house.floor);
        }
      });
      this.floors = this.removeDuplicados(this.floors);
      this.portalSelected = true;
    } else {
      this.portalSelected = false;
      this.componentsValues.floor = null;
      this.selectFloor();
    }
  }

  selectFloor() {
    this.letters = [];
    this.floorSelected = false;
    this.componentsValues.door = null;
    if (this.componentsValues.floor) {
      this.houses.forEach(house => {
        if ((this.componentsValues.portal === house.portal) && (this.componentsValues.floor === house.floor)) {
          this.letters.push(house.letter);
        }
      });
      this.letters = this.removeDuplicados(this.letters);
      this.floorSelected = true;
    } else {
      this.floorSelected = false;
      this.componentsValues.door = null;
    }
  }

  updateFiltro() {
    if ( !this.componentsValues ) { return; }
    const isFilterChanged = this.compareFilterValuesWithFilter();
    this.updateCsites();
    this.updateHouseOrCommonArea();
    this.updateId();
    if (isFilterChanged) {
      this.filterChange.emit(this.filter);
    }
  }

  private compareFilterValuesWithFilter(): boolean {
    let isFilterChanged: boolean = false;
    if (this.componentsValues.csiteId !== this.filter.csite_id ) {
      isFilterChanged = true;
    } else if (this.componentsValues.commonArea !== this.filter.common_area) {
      isFilterChanged = true;
    } else if (this.componentsValues.portal !== this.filter.portal) {
      isFilterChanged = true;
    } else if (this.componentsValues.floor !== this.filter.floor) {
      isFilterChanged = true;
    } else if (this.componentsValues.door !== this.filter.letter) {
      isFilterChanged = true;
    } else if (this.componentsValues.idSelected !== this.filter.id) {
      isFilterChanged = true;
    } else {
      isFilterChanged = false;
    }
    return isFilterChanged;
  }

  private updateHouseOrCommonArea() {
    this.reloadIfIsNeededHouseOrCommonAreaSelectBox();
    this.filter.common_area = this.componentsValues.commonArea;
    this.filter.portal = this.componentsValues.portal;
    this.filter.floor = this.componentsValues.floor;
    this.filter.letter = this.componentsValues.door;
  }

  removeDuplicados(list: string[]): string[] {
    return list.filter((item, index) => {
      return list.indexOf(item) === index;
    });
  }

  private reloadIfIsNeededHouseOrCommonAreaSelectBox() {
    if (this.filter.common_area !== this.componentsValues.commonArea) {
      this.reloadPortalSelect();
    } else if (this.filter.portal !== this.componentsValues.portal) {
      this.reloadFloorSelect();
    } else if (this.filter.floor !== this.componentsValues.floor) {
      this.reloadDoorSelect();
    }
  }

  private loadDoorSelect() {
    this.letters = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          house.floor === this.componentsValues.floor &&
          this.letters.indexOf(house.letter) < 0) {
        this.letters.push(house.letter);
      }
    }
    this.letters.sort();
  }
  private reloadDoorSelect() {
    if (this.componentsValues.floor) {
      this.loadDoorSelect();
    } else {
      this.letters = null;
    }
    this.componentsValues.door = null;
  }

  private reloadFloorSelect() {
    if (this.componentsValues.portal) {
      this.loadFloorSelect();
    } else {
      this.floors = null;
    }
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.letters = null;
  }

  private loadFloorSelect() {
    this.floors = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          this.floors.indexOf(house.floor) < 0) {
        this.floors.push(house.floor);
      }
    }
    this.floors.sort();
  }

  private reloadPortalSelect() {
    if (!this.componentsValues.commonArea) {
      this.loadPortalSelect();
    } else {
      this.portals = null;
    }
    this.componentsValues.portal = null;
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.floors = null;
    this.letters = null;
  }

  private loadPortalSelect() {
    this.portals = [];
    for (const house of this.houses) {
      if (house.common_area === this.componentsValues.commonArea &&
          this.portals.indexOf(house.portal) < 0) {
        this.portals.push(house.portal);
      }
    }
    this.portals.sort();
  }

  private updateId() {
    this.filter.id = this.componentsValues.idSelected;
  }

  private updateCsites() {
    this.filter.csite_id = this.componentsValues.csiteId;
  }

  public dismiss() {
    this.detectChanges = false;
    this.modalController.dismiss({
      dismissed: true
    }, null, this.modalId);
  }

}
